/**
 * Product Selection Sections JavaScript
 * Handles MERV Rating Learn More links and Quantity Selector functionality
 */

document.addEventListener('DOMContentLoaded', function() {
  // Prefer this pack size by default where possible
  const PREFERRED_DEFAULT_PACK_SIZE = 6;
  // Handle Learn More clicks to prevent radio selection
  const learnMoreLinks = document.querySelectorAll('.merv-learn-more');
  
  learnMoreLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
      // Stop the click from bubbling up to the label (which would select the radio)
      e.stopPropagation();
      // Let the link work normally - don't prevent default!
    });
  });
  
  // Add hover effects for better UX
  const optionLabels = document.querySelectorAll('.merv-option-label');
  
  optionLabels.forEach(function(label) {
    label.addEventListener('mouseenter', function() {
      const input = this.querySelector('.merv-option-input');
      if (input && !input.checked) {
        this.style.transform = 'translateY(-1px)';
        this.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
      }
    });
    
    label.addEventListener('mouseleave', function() {
      this.style.transform = 'translateY(0)';
      this.style.boxShadow = 'none';
    });
  });

  // ===================================
  // QUANTITY SELECTOR FUNCTIONALITY (PACK SIZE)
  // ===================================

  // Initialize pack size functionality
  initializePackSizeSelector();
  
  // Initialize discount table and about variant title
  setTimeout(function() {
    updateDiscountTable();
    updateAboutVariantTitle();
  }, 100);
  
  // Ensure a preferred pack size is selected on page load
  setTimeout(function() {
    const urlHasVariant = new URLSearchParams(window.location.search).has('variant');

    const availableSizes = getAvailablePackSizes();
    if (availableSizes.length === 0) return;

    // If URL specifies a variant, sync UI to that variant's pack size and exit
    if (urlHasVariant) {
      const variantPicker = document.querySelector('variant-picker');
      let currentFromVariant = null;
      if (variantPicker && variantPicker.variant && Array.isArray(variantPicker.variant.options)) {
        const maybeSize = parseInt(variantPicker.variant.options[1]);
        currentFromVariant = Number.isFinite(maybeSize) ? maybeSize : null;
      }

      // Fallback to hidden option radio if available
      if (!currentFromVariant) {
        const selectedPackSizeInput = document.querySelector('.hidden-option input[type="radio"]:checked');
        currentFromVariant = selectedPackSizeInput ? parseInt(selectedPackSizeInput.value) : null;
      }

      if (currentFromVariant) {
        // Reflect the current selection in the UI and computed displays
        updateQuantityDisplay(currentFromVariant);
        updateDiscountTable();
      }
      return;
    }

    // Otherwise prefer default pack size (6) or lowest available
    const preferred = availableSizes.includes(PREFERRED_DEFAULT_PACK_SIZE)
      ? PREFERRED_DEFAULT_PACK_SIZE
      : availableSizes[0];

    updatePackSize(preferred);
    // Ensure dependent UI (savings, per-each, tables, alt title) is correct on first paint
    updateDiscountTable();
    updateAboutVariantTitle();
  }, 500);

  // Listen for variant changes to update available pack sizes
  document.addEventListener('on:variant:change', function(event) {
    updateAvailablePackSizes();
    updateDiscountTable();
  });
  
  // Listen for MERV rating changes
  document.addEventListener('change', function(event) {
    if (event.target.classList.contains('merv-option-input')) {
      updateDiscountTable();
      updateAboutVariantTitle();
    }
  });

  function initializePackSizeSelector() {
    const quantitySelectors = document.querySelectorAll('.quantity-selector');
    
    quantitySelectors.forEach(function(selector) {
      const minusBtn = selector.querySelector('.quantity-btn--minus');
      const plusBtn = selector.querySelector('.quantity-btn--plus');
      const input = selector.querySelector('.quantity-input.pack-size-selector');
      
      if (!minusBtn || !plusBtn || !input) return;
      
      // Handle minus button - go to previous pack size
      minusBtn.addEventListener('click', function() {
        const availableSizes = getAvailablePackSizes();
        const currentValue = parseInt(input.value) || availableSizes[0];
        const currentIndex = availableSizes.indexOf(currentValue);
        
        if (currentIndex > 0) {
          const newValue = availableSizes[currentIndex - 1];
          updatePackSize(newValue);
        }
      });
      
      // Handle plus button - go to next pack size
      plusBtn.addEventListener('click', function() {
        const availableSizes = getAvailablePackSizes();
        const currentValue = parseInt(input.value) || availableSizes[0];
        const currentIndex = availableSizes.indexOf(currentValue);
        
        if (currentIndex < availableSizes.length - 1) {
          const newValue = availableSizes[currentIndex + 1];
          updatePackSize(newValue);
        }
      });
      
      // Disable direct input - pack sizes only
      input.addEventListener('keydown', function(e) {
        e.preventDefault();
      });
    });
    
    // Initialize with current pack size
    updateAvailablePackSizes();
  }

  function getAvailablePackSizes() {
    // Get the currently selected MERV rating
    const selectedMervInput = document.querySelector('.merv-option-input:checked');
    if (!selectedMervInput) {
      return [2, 4, 6, 12]; // Default pack sizes
    }
    
    const selectedMerv = selectedMervInput.value;
    
    // Get product data from variant picker
    const variantPicker = document.querySelector('variant-picker');
    if (!variantPicker || !variantPicker.data) {
      return [2, 4, 6, 12]; // Default pack sizes
    }
    
    // Find all variants with this MERV rating and extract unique pack sizes
    const variants = variantPicker.data.product.variants;
    const packSizes = [];
    
    variants.forEach(function(variant) {
      if (variant.options[0] === selectedMerv) {
        const packSize = parseInt(variant.options[1]);
        if (!packSizes.includes(packSize)) {
          packSizes.push(packSize);
        }
      }
    });
    
    // Sort pack sizes numerically
    return packSizes.sort((a, b) => a - b);
  }

  function updatePackSize(newSize) {
    // console.log('[DEBUG] updatePackSize called with:', newSize);
    
    // Update the pack size selector display (NOT regular quantity inputs)
    const packSizeInputs = document.querySelectorAll('.quantity-input.pack-size-selector');
    packSizeInputs.forEach(function(input) {
      input.value = newSize;
    });
    
    // Find and update the hidden pack size selector
    const hiddenOption = document.querySelector('.hidden-option');
    if (hiddenOption) {
      // Try radio buttons first
      const packSizeRadios = hiddenOption.querySelectorAll('input[type="radio"]');
      let found = false;
      
      packSizeRadios.forEach(function(input) {
        if (input.value === newSize.toString()) {
          input.click();
          found = true;
        }
      });
      
      // If no radios, try select dropdown
      if (!found) {
        const packSizeSelect = hiddenOption.querySelector('select');
        if (packSizeSelect) {
          packSizeSelect.value = newSize.toString();
          packSizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
    
    // Update displays
    updateQuantityDisplay(newSize);
    
    // Update button states
    const availableSizes = getAvailablePackSizes();
    const currentIndex = availableSizes.indexOf(newSize);
    
    document.querySelectorAll('.quantity-selector').forEach(function(selector) {
      const minusBtn = selector.querySelector('.quantity-btn--minus');
      const plusBtn = selector.querySelector('.quantity-btn--plus');
      
      if (minusBtn) minusBtn.disabled = currentIndex === 0;
      if (plusBtn) plusBtn.disabled = currentIndex === availableSizes.length - 1;
    });
  }

  function updateAvailablePackSizes() {
    // console.log('=== updateAvailablePackSizes called ===');
    const availableSizes = getAvailablePackSizes();
    // console.log('Available sizes:', availableSizes);
    
    if (availableSizes.length === 0) return;
    
    const packSizeInputs = document.querySelectorAll('.quantity-input.pack-size-selector');
    
    packSizeInputs.forEach(function(input) {
      // Get current pack size from hidden option
      const selectedPackSizeInput = document.querySelector('.hidden-option input[type="radio"]:checked');
      // console.log('Selected pack size input:', selectedPackSizeInput ? selectedPackSizeInput.value : 'none');
      const currentPackSize = selectedPackSizeInput ? parseInt(selectedPackSizeInput.value) : null;
      
      // If no pack size selected or current pack size is not available for new MERV, select preferred or lowest
      if (!currentPackSize || !availableSizes.includes(currentPackSize)) {
        const preferred = availableSizes.includes(PREFERRED_DEFAULT_PACK_SIZE)
          ? PREFERRED_DEFAULT_PACK_SIZE
          : availableSizes[0];
        // console.log('Selecting preferred available pack size:', preferred);
        updatePackSize(preferred);
      } else {
        input.value = currentPackSize;
      }
      
      // Update button states
      const selector = input.closest('.quantity-selector');
      if (selector) {
        const minusBtn = selector.querySelector('.quantity-btn--minus');
        const plusBtn = selector.querySelector('.quantity-btn--plus');
        const currentIndex = availableSizes.indexOf(parseInt(input.value));
        
        if (minusBtn) minusBtn.disabled = currentIndex === 0;
        if (plusBtn) plusBtn.disabled = currentIndex === availableSizes.length - 1;
      }
    });
  }
  
  // Update quantity-related displays
  function updateQuantityDisplay(quantity) {
    // console.log('[DEBUG] updateQuantityDisplay called with:', quantity);
    
    // ===================================
    // DO NOT SYNC PACK SIZE TO QUANTITY INPUT!
    // Pack size is a variant option (how many filters in a pack)
    // Quantity is how many packs to add to cart
    // These are SEPARATE concepts
    // ===================================
    
    // We should NOT be updating input[name="quantity"] here
    // That's the actual cart quantity, not the pack size!
    
    // ===================================
    // UPDATE OUR CUSTOM DISPLAYS
    // ===================================
    
    // Update quantity count in description
    const quantityCountElement = document.querySelector('.quantity-count');
    if (quantityCountElement) {
      quantityCountElement.textContent = quantity;
    }
    
    // Get currently selected MERV and variant picker data
    const selectedMervInput = document.querySelector('.merv-option-input:checked');
    const variantPicker = document.querySelector('variant-picker');
    
    if (selectedMervInput && variantPicker && variantPicker.data) {
      const selectedMerv = selectedMervInput.value;
      const variants = variantPicker.data.product.variants;
      
      // Find base price (smallest pack size) and current price
      let baseVariant = null;
      let currentVariant = null;
      
      variants.forEach(function(variant) {
        if (variant.options[0] === selectedMerv) {
          const packSize = parseInt(variant.options[1]);
          if (!baseVariant || packSize < parseInt(baseVariant.options[1])) {
            baseVariant = variant;
          }
          if (packSize === quantity) {
            currentVariant = variant;
          }
        }
      });
      
      // Update savings percentage
      const savingsContainer = document.querySelector('.quantity-savings');
      const savingsElement = document.querySelector('.savings-percentage');
      const savingsText = document.querySelector('.savings-text');
      const standardPriceText = document.querySelector('.standard-price-text');
      
      if (savingsContainer && savingsElement && baseVariant && currentVariant) {
        const basePricePerFilter = baseVariant.price / parseInt(baseVariant.options[1]);
        const currentPricePerFilter = currentVariant.price / quantity;
        const savingsPercent = ((basePricePerFilter - currentPricePerFilter) / basePricePerFilter * 100).toFixed(0);
        
        if (savingsPercent > 0) {
          savingsElement.textContent = savingsPercent + '%';
          savingsContainer.style.display = 'block';
          if (savingsText) savingsText.style.display = 'inline';
          if (standardPriceText) standardPriceText.style.display = 'none';
        } else {
          // Show "Standard price" for the smallest pack size
          savingsContainer.style.display = 'block';
          if (savingsText) savingsText.style.display = 'none';
          if (standardPriceText) standardPriceText.style.display = 'inline';
        }
      } else if (savingsContainer) {
        savingsContainer.style.display = 'none';
      }
      
      // Update price per each
      const priceEachElement = document.querySelector('.price-each');
      if (priceEachElement && currentVariant) {
        const pricePerFilter = currentVariant.price / quantity / 100; // Convert cents to dollars
        priceEachElement.textContent = `$${pricePerFilter.toFixed(0)}`;
      }
    }
    
    // console.log(`Custom quantity selector updated to: ${quantity}, synced with existing form`);
  }
  
  // ===================================
  // DO NOT SYNC QUANTITY AND PACK SIZE
  // ===================================
  
  // REMOVED: We were incorrectly syncing the actual quantity input with pack size
  // These are separate concepts:
  // - Pack size = variant option (2, 4, 6, 12 filters per pack)  
  // - Quantity = how many packs to add to cart
  
  // Helper function to update only custom displays (no sync)
  function updateCustomDisplaysOnly(quantity) {
    // Just call the main update function but without syncing
    updateQuantityDisplay(quantity);
  }
  
  // ===================================
  // UPDATE ABOUT VARIANT TITLE (for product2 template)
  // ===================================
  
  function updateAboutVariantTitle() {
    // Only run if the element exists (product2 template)
    const aboutVariantTitle = document.querySelector('.alt-template-about-variant-title');
    if (!aboutVariantTitle) return;
    
    // Get currently selected MERV rating
    const selectedMervInput = document.querySelector('.merv-option-input:checked');
    if (!selectedMervInput) return;
    
    const selectedMerv = selectedMervInput.value;
    aboutVariantTitle.textContent = ` About ${selectedMerv} `;
    
    // Update MERV descriptions
    updateMervDescription(selectedMerv);
  }
  
  function updateMervDescription(selectedMerv) {
    // Only run if the wrapper exists (product2 template)
    const descriptionWrapper = document.querySelector('.merv-description__wrapper');
    if (!descriptionWrapper) return;
    
    // Hide all descriptions
    const allDescriptions = descriptionWrapper.querySelectorAll('.merv-description__text');
    allDescriptions.forEach(function(desc) {
      desc.style.display = 'none';
    });
    
    // Strip out carbon variations to get base MERV rating
    // "MERV 11 + CARBON" -> "MERV 11"
    let baseMerv = selectedMerv;
    const carbonVariations = [' + CARBON', ' + Carbon', '+CARBON', '+Carbon', ' + carbon', '+carbon'];
    carbonVariations.forEach(function(variation) {
      baseMerv = baseMerv.replace(variation, '');
    });
    baseMerv = baseMerv.trim();
    
    // Convert MERV value to handleized format to match the IDs
    // "MERV 6" -> "merv-6", "MERV 11" -> "merv-11", etc.
    const handleizedMerv = baseMerv.toLowerCase().replace(/\s+/g, '-').replace(/\+/g, '');
    
    // Try different variations to match the IDs in the HTML
    const possibleIds = [
      handleizedMerv,                                    // "merv-6"
      handleizedMerv.replace('-', ''),                   // "merv6"
      baseMerv.toLowerCase().replace(/\s+/g, ''),        // "merv6"
      baseMerv.toLowerCase().replace('merv ', 'merv-'),  // "merv-6"
      baseMerv.toLowerCase().replace('merv ', 'merv')    // "merv6"
    ];
    
    // Try to find and show the matching description
    let found = false;
    for (const id of possibleIds) {
      const matchingDescription = document.getElementById(id);
      if (matchingDescription) {
        matchingDescription.style.display = 'block';
        found = true;
        break;
      }
    }
    
    if (!found) {
      console.log('No description found for MERV:', selectedMerv, 'Base MERV:', baseMerv, 'Tried IDs:', possibleIds);
    }
  }
  
  // ===================================
  // DISCOUNT TABLE GENERATION
  // ===================================
  
  function updateDiscountTable() {
    // Update ALL discount tables (handles both locations)
    const discountTables = document.querySelectorAll('[data-discount-table]');
    if (discountTables.length === 0) return;
    
    // Get currently selected MERV rating
    const selectedMervInput = document.querySelector('.merv-option-input:checked');
    if (!selectedMervInput) return;
    
    const selectedMerv = selectedMervInput.value;
    
    // Get variant picker data
    const variantPicker = document.querySelector('variant-picker');
    if (!variantPicker || !variantPicker.data) return;
    
    const variants = variantPicker.data.product.variants;
    const formatted = variantPicker.data.formatted;
    
    // Get all pack size variants for selected MERV
    const packSizeVariants = [];
    variants.forEach(function(variant) {
      if (variant.options[0] === selectedMerv) {
        const packSize = parseInt(variant.options[1]);
        packSizeVariants.push({
          packSize: packSize,
          variant: variant,
          pricePerFilter: variant.price / packSize / 100, // Convert cents to dollars per filter
          formattedPrice: formatted[variant.id].price
        });
      }
    });
    
    // Sort by pack size
    packSizeVariants.sort((a, b) => a.packSize - b.packSize);
    
    // Find the base price (smallest pack size)
    const basePrice = packSizeVariants.length > 0 ? packSizeVariants[0].pricePerFilter : 0;
    
    // Generate table rows
    let tableHTML = '';
    packSizeVariants.forEach(function(item, index) {
      const savings = basePrice > 0 ? ((basePrice - item.pricePerFilter) / basePrice * 100).toFixed(0) : 0;
      
      tableHTML += '<div class="discount-row">';
      tableHTML += '<div class="discount-left">';
      tableHTML += '<span class="discount-qty">' + item.packSize + '</span> for ';
      tableHTML += '<span class="discount-price">$' + item.pricePerFilter.toFixed(0) + '</span> ea';
      tableHTML += '</div>';
      tableHTML += '<div class="discount-right">';
      
      if (index === 0) {
        tableHTML += '<span class="discount-savings standard">Standard price</span>';
      } else if (savings > 0) {
        tableHTML += '<span class="discount-savings save">Save ' + savings + '%</span>';
      } else {
        tableHTML += '<span class="discount-savings standard">Standard price</span>';
      }
      
      tableHTML += '</div>';
      tableHTML += '</div>';
    });
    
    // Update all discount tables with the same content
    discountTables.forEach(function(table) {
      table.innerHTML = tableHTML;
    });
  }
  
  // ===================================
  // INITIALIZATION FUNCTION
  // ===================================
  
  function initializeQuantitySync() {
    // DO NOT sync quantity and pack size - they are different things!
    // Just add the fallback class
    document.body.classList.add('custom-quantity-active');
    // console.log('Pack size selector initialized');
  }
}); 